const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "328.09 245.393 13.187 12.967",
    width: 13.187,
    height: 12.967,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 339.816 248.063 C 340.032 247.847 340.01 247.485 339.753 247.318 C 338.215 246.319 336.421 245.789 334.587 245.792 C 332.682 245.792 330.907 246.352 329.421 247.318 C 329.167 247.489 329.137 247.851 329.358 248.063 C 329.534 248.234 329.804 248.261 330.01 248.128 C 331.376 247.253 332.965 246.789 334.587 246.792 C 336.209 246.789 337.798 247.253 339.164 248.128 C 339.369 248.26 339.644 248.236 339.816 248.063 M 337.633 250.246 C 337.859 250.02 337.818 249.641 337.533 249.496 C 336.62 249.032 335.611 248.791 334.587 248.792 C 333.527 248.792 332.525 249.046 331.641 249.496 C 331.356 249.641 331.315 250.02 331.541 250.246 L 331.556 250.261 C 331.716 250.421 331.964 250.451 332.167 250.351 C 332.921 249.982 333.748 249.791 334.587 249.792 C 335.455 249.792 336.277 249.993 337.007 250.352 C 337.21 250.452 337.457 250.422 337.618 250.261 L 337.633 250.246 Z M 335.647 252.232 C 335.843 252.036 335.845 251.712 335.607 251.572 C 335.298 251.388 334.946 251.292 334.587 251.292 C 334.228 251.292 333.876 251.388 333.567 251.572 C 333.329 251.712 333.331 252.036 333.527 252.232 L 334.233 252.938 C 334.428 253.133 334.746 253.133 334.941 252.938 L 335.648 252.231 L 335.647 252.232 Z",
    style: {
      transformOrigin: "334.586px 249.438px"
    },
    transform: "matrix(-1, 0, 0, -1, 0, 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    },
    cx: 334.81,
    cy: 256.453,
    rx: 4.094,
    ry: 0.919
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHole);
export default __webpack_public_path__ + "static/media/hole.dcb93a29974deb6e0d49bcab8b2f85d1.svg";
export { ForwardRef as ReactComponent };